import { useTranslation } from "@outschool/localization";
import { onlineClassesPath } from "@outschool/routes";
import { useQueryWithPreviousData } from "@outschool/ui-apollo";
import { searchListingsQuery } from "@outschool/ui-components-website";
import _ from "lodash";
import React from "react";

import * as Env from "../../../../shared/Env";
import {
  dateFilter,
  findWeight,
  makeCardDefinition
} from "../../../../shared/parentDashboard/cardTypes/Topic";
import { TopicDefinitions } from "../../../../shared/parentDashboard/cardTypes/TopicDefinitions";
import { useTimeZone } from "../../../providers/TimeZoneProvider";
import * as Topic from "../cardTypes/Topic";
import { MobileParentDashboardLearnerInterestListingsQuery } from "../lists/LearnerInterestsList";
import TabContent from "./TabContent";

export default function LearnerTab({ learner }: $TSFixMe) {
  const { t } = useTranslation(
    "client\\components\\parentDashboard\\tabs\\LearnerTab"
  );

  //   Within each learner bundle, show a blend of classes that are recommended based on the learner’s interests
  const hasInterests = !!learner?.interestTopics.topics.length;

  const query = hasInterests
    ? MobileParentDashboardLearnerInterestListingsQuery
    : searchListingsQuery;
  const vars = hasInterests
    ? {
        skipRating: false,
        learnerUid: learner?.uid
      }
    : {
        searchFilters: { age: learner?.age.toString(), isAvailable: true },
        order: "popular",
        limit: 50
      };
  const { loading, data } = useQueryWithPreviousData(query, {
    skip: !!Env.FEATURE_FLAGS.DISABLE_OPTIONAL_QUERIES,
    variables: {
      skipRating: false,
      withRecentReviews: false,
      ...vars
    },
    context: { doNotRetry: true }
  });

  const listings = loading
    ? []
    : hasInterests
    ? data?.featured?.learnerInterestTopicListings
    : data?.searchListings?.listings;

  // carousels
  // if has recommended categories show a carousel for each, up to 5
  const carousels = [];
  const categoryData = loading ? {} : learner?.recommendedCategories;
  const { timeZone } = useTimeZone();

  carousels.push(
    // @ts-ignore TS(2345): Argument of type 'Element' is not assignable to pa... Remove this comment to see the full error message
    ...Object.values(_.omit(categoryData, ["__typename"])).map(c => {
      delete c.searchFilters.__typename;
      c.searchFilters["age"] = learner?.age.toString();
      c.searchFilters["timeZone"] = timeZone;
      c.searchFilters["isAvailable"] = true;
      const title = c.nameTitleCased[0] + c.nameSentenceCased.slice(1);
      return (
        <Topic.Component
          /* eslint-disable-next-line i18next/no-literal-string */
          card={makeCardDefinition({
            ...c,
            display: "list",
            id: c.slug,
            title: title,
            url: onlineClassesPath(c.slug, c.basePath)
          })}
          trackingProperties={{}}
          loadAfterDelay={0}
          isCategory={true}
        />
      );
    })
  );

  // else show carousels for 5 random topics based on age per sushi
  // order the topics by relevance for age, take top 5
  const ageBasedTopics = dateFilter(TopicDefinitions)
    .sort((a: $TSFixMe, b: $TSFixMe) => {
      const weightA = findWeight(a.criteria.weightsByAge, learner?.age);
      const weightB = findWeight(b.criteria.weightsByAge, learner?.age);
      return weightB - weightA;
    })
    .slice(0, 5);

  const maxCarousels =
    ageBasedTopics.length + carousels.length >= 5
      ? 5
      : ageBasedTopics.length + carousels.length;

  while (carousels.length < maxCarousels) {
    const cardDefinition = makeCardDefinition(ageBasedTopics.shift());
    // @ts-ignore
    cardDefinition["display"] = "list";
    // @ts-ignore
    cardDefinition.searchFilters["age"] = learner?.age.toString();
    // @ts-ignore
    cardDefinition.searchFilters["isAvailable"] = true;
    carousels.push(
      // @ts-ignore TS(2345): Argument of type 'Element' is not assignable to pa... Remove this comment to see the full error message
      <Topic.Component
        key={`carousel-card-${cardDefinition.id}`}
        card={cardDefinition}
        trackingProperties={{}}
        loadAfterDelay={0}
      />
    );
  }

  return (
    <TabContent
      title={t("Classes and topics for ") + learner?.name}
      listings={listings}
      listingsLoading={loading}
      carousels={carousels}
    />
  );
}
